module.exports = __webpack_public_path__ + "img/cash_top_reverse.a7edf281.png";